export function container(diameter) {
  let background = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'white';
  let className = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  let _style = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  const element = document.createElement('div');
  const style = Object.assign({
    background,
    borderRadius: "".concat(diameter / 2, "px"),
    display: 'inline-block',
    height: "".concat(diameter, "px"),
    margin: '0px',
    overflow: 'hidden',
    padding: '0px',
    width: "".concat(diameter, "px")
  }, _style);
  element.className = className;
  element.style.background = background;
  Object.keys(style).forEach(key => {
    element.style[key] = style[key];
  });
  return element;
}